import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AmortizationPageComponent } from './amortization.page';

const routes: Routes = [
  {
    component: AmortizationPageComponent,
    path: ''
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class AmortizationPageRoutingModule {}
